import type { PropsWithChildren } from 'react';

import { Collapse, type CollapseProps } from '@mui/material';

interface IHorizontalExpansionTransition extends CollapseProps {
  isOpen: boolean;
}

export const HorizontalExpansionTransition = ({
  isOpen,
  children,
  ...properties
}: PropsWithChildren<IHorizontalExpansionTransition>) => (
  <Collapse in={isOpen} orientation={properties.orientation} {...properties}>
    {children}
  </Collapse>
);
